import { render, staticRenderFns } from "./DetalheTituloRevisao.vue?vue&type=template&id=5d17aae2&scoped=true"
import script from "./DetalheTituloRevisao.vue?vue&type=script&lang=js"
export * from "./DetalheTituloRevisao.vue?vue&type=script&lang=js"
import style0 from "./DetalheTituloRevisao.vue?vue&type=style&index=0&id=5d17aae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17aae2",
  null
  
)

export default component.exports